<template lang="pug">
  page

    section.challenge-content
      .container(v-if="sending")
        content-placeholders(:animated="true")
          .row
            .col-sm-8
              content-placeholders-heading(:img="true")
              content-placeholders-text(v-for="i in 5" :key="i")
            .col-sm-4
              content-placeholders-img
              content-placeholders-text

      .container(v-else)
        .row.align-items-center.pb-5.mb-5.bb-grey
          .col-sm-12.mb-5
            router-link(:to="{name: 'Challenges'}")
              i.feather-arrow-left
              | See All Challenges
          .col-sm-9
            h1 {{challenge.title}}
            .text-muted
              i.feather-tag
              span.ml-2 {{challenge.sector}}
              i.feather-clock.ml-4
              span.ml-2 Last Date {{$moment(challenge.expiry).fromNow()}}
          .col-sm-3.text-sm-right(v-if="not_expired")
            a.button.ml-auto(href="#" v-if="challenge.application_type=='internal'" @click.prevent="openModal") Apply Now
            a.button.ml-auto(:href="challenge.application_link" target="_blank" v-else) Apply Now
          .col-sm-3.text-sm-right(v-else)
            b Application Closed

        .row
          .col-sm-8
            p.text-justify(v-if="challenge.entity") 
              b About {{challenge.entity.name}}
            p.text-justify(v-if="challenge.entity")  {{challenge.entity.about}}

            .text-justify(v-html="challenge.description")
            
            p.text-justify 
              b Eligibility
            p.text-justify
              ul
                li(v-for="item in eligibility") {{item}}
            div(v-if="not_expired")
              a.button.mt-5(href="#" v-if="challenge.application_type=='internal'" @click.prevent="openModal") Apply Now
              a.button.mt-5(:href="challenge.application_link" target="_blank" v-else) Apply Now
            b(v-else) Application Closed

            share_button(
              :title="'Business 4 Startups - '+ challenge.entity.name +' Problem Statement - '+challenge.title" 
              :url="current_url"
              :description="challenge.entity.about"
              :quotes="challenge.entity.about"
              :hashtags="challenge.sector.split(' ').join('_')+',Kerala,KSUM,Kerala_Startup_Mission,Business_4_Startups'"
              twitter_user="startup_mission"
              v-if="challenge.entity"
            )
          
          .col-sm-4(v-if="challenge.entity")
            .details.mx-5.py-5.mt-5
              img.img-fluid(:src='$backend+"/storage/logos/"+challenge.entity.logo')
              .text-center
                b {{challenge.entity.name}}
              .text-muted.text-center {{challenge.entity.state}}, {{challenge.entity.country}}
              a.text-center.small.mx-auto.d-block.mt-2(:href="challenge.entity.website" target="_blank") {{challenge.entity.website}}
              p.text-center.mt-3 
                b Last Date: {{$moment(challenge.expiry).format('DD MMM YYYY')}}

            .video-block.mx-5.mt-4(v-if="challenge.video")
              a.video-pop-up(@click="open_video()")
                img(:src="`https://img.youtube.com/vi/${youtube_id}/hqdefault.jpg`")
            #youtube.modal.modal-blur.fade.show(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true' )
              .modal-dialog.modal-dialog-centered.modal-lg(role='document')
                .modal-content
                  .modal-body
                    iframe(type='text/html' width='670' height='400' :src="`//www.youtube.com/embed/${youtube_id}`" frameborder='0')

      modal#modal_form(title="Apply for Challenge" size="modal-lg" @save="submitApplication")
        .row
          .col-sm-6
            form_input(type="text" name="startup" label="Startup Name *" placeholder="Startup Name" v-model="form.startup" :required="true")  
          .col-sm-6
            form_input(type="text" name="founder" label="Founder Name *" placeholder="Founder Name" v-model="form.founder" :required="true")  
        .row
          .col-sm-6
            form_input(type="email" name="email" label="Email ID *" placeholder="Email ID" v-model="form.email" :required="true")  
          .col-sm-6
            form_input(type="number" name="phone" label="Contact Number *" placeholder="Contact Number" v-model="form.phone" :required="true")  

        .row
          .col-sm-4
            form_input(type="text" name="dipp" label="DPIIT Number *" placeholder="DPIITxxxxx" v-model="form.dipp" :required="true")  
          .col-sm-4
            .mb-3
              label.form-label Is your startup registered in Kerala?
              label.form-check.form-switch
                input.form-check-input(type='checkbox' v-model='form.kerala')
                span.form-check-label Yes
          .col-sm-4(v-if="form.kerala")
            form_input(type="text" name="uid" label="KSUM Unique ID *" placeholder="DPIITxxxxx/YYYY/KSUMxxx" v-model="form.uid" :required="true")  

        .row
          .col-sm-12
              label.form-label Proposed Solution *
                span.form-label-description {{remain}} characters remaining
              textarea.form-control(v-model="form.solution" rows="5" maxlength="250" :required="true")
              form_error(:errors="errors?errors['solution']:[]")


        .row
          .col-sm-6
            .mb-3
              label.form-label Upload Pitch Deck (specific to the challenge) *
              .form-file
                input#customFile.form-file-input(type='file' @change="onFileChange" accept=".pdf")
                label.form-file-label(for='customFile')
                  span.form-file-text {{filename}}
                  span.form-file-button Browse
                form_error(:errors="errors?errors['file']:[]")
                
          .col-sm-6
            form_select(name="status" label="Current Status of Your Solution *" v-model="form.current" :options="['Ready to be implemented','Need to customize my existing solution','I have to develop the solution from scratch']" :required="true")
        
        .row
          .col-sm-6
            form_input(type="url" name="video" label="Video URL" placeholder="Youtube/Vimeo video" v-model="form.video")  
          .col-sm-6
            form_input(type="url" name="url" label="Additional Documents" placeholder="Google Drive/ Dropbox Link" v-model="form.url" )  

        .row
          .col-sm-12
            label.form-check.form-switch
              input.form-check-input(type='checkbox' v-model="form.terms")
              span.form-check-label I agree with 
                router-link(:to="{name: 'termsandcondition'}" target="_blank") terms and conditions
              form_error(:errors="errors?errors['terms']:[]")


</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page';
import magnificPopup from 'magnific-popup';
import share_button from '@/components/share_button';
import modal from '@/components/modal';
import form_input from '@/components/formInput' 
import form_select from '@/components/formSelect'
import formError from '@/components/formErrors';
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ChallengeDetails',
  components: {
    page,
    share_button,
    modal,form_input,form_select,
    form_error: formError,
  },
  props: ['id'],
  data(){
    return {
      challenge : {},
      filename: 'Choose file...',
      form: {
        solution: ''
      }
    }
  },
  computed:{
    remain(){
      return 250-this.form.solution.length
    },
    current_url(){
      if(window.location){
        return window.location.href;
      }
    },
    eligibility(){
      if(this.challenge.eligibility){
        return this.challenge.eligibility.split('\n');
      }
    },
    youtube_id(){
      var url = this.challenge.video??'';
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
      // return video_id;
    },
    not_expired(){
      if(this.challenge.expiry){
        var today = this.$moment();
        var expiry = this.$moment(this.challenge.expiry);
        // console.log(today.format('YYYY-MM-DD HH:mm:ss'),this.challenge.expiry, expiry.format('DD MMM YYYY HH:mm'))
        return today.isBefore(expiry);
      }
    },
    
    ...mapState('api', ['sending','errors']),
  },
  methods: {
    openModal(){
      $('#modal_form').modal('show');
      this.$gtag.event('apply', { method: 'internal' })
    },
    open_video(){
      $('#youtube').modal('show');
    },
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'challenges/'+this.id, method: 'GET'})
        .then((response)=>{
          vm.challenge = response;
          if(response.restrict){
            //check if login else redirect to login page
            vm.checklogin().then(function(){
              console.log('loggedin');
            }).catch(function(){
              vm.$router.push({ name: 'Login', params: { to: vm.$route } });
            })
          }
        });
    },
    onFileChange(e){
      console.log(e.target.files);
      this.filename = e.target.files[0].name;
      this.form.file = e.target.files[0];
    },
    submitApplication(){
      var vm = this;

      let formData = new FormData();

      Object.entries(this.form).map(item => {
        formData.append(item[0], item[1]);
      })

      this.call({ _vm: this, endpoint:'application/'+this.id, method: 'POST', data:formData, config:{ headers: {'Content-Type': 'multipart/form-data'} }})
        .then((response)=>{
          $('#modal_form').modal('hide');
          alert(response.message);
        });
    },
    ...mapActions('api', ['call']),
    ...mapActions('auth', ['checklogin'])
  },
  mounted(){
    this.load_data();
    $('.video-pop-up').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';

.text-justify{
  text-align: justify;
}

.bb-grey{
  border-bottom: 1px solid rgba(200,200,200,.5);
}

.video-block{
  display: inline-block;
  background: white;
  padding: 10px 10px 10px 10px;
  box-shadow: 1px 1px 3px #666;

  iframe{
    max-width: 100%;
  }

  img{
    max-width:100%;
  }
}

.challenge-content{
  padding-top: 60px;
  padding-bottom: 60px;
  @include my_bp(sm){
    padding-top: 150px;
  }
  h1{
    font-weight: 400;
    font-size: 1.8rem;
  }
  .button{
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: all 0.2s ease-in-out;
    color: #fff;
    background-color: #377dff;
    border-color: #377dff;

    &:hover{
      text-decoration: none;
      color: #fff;
      background-color: #1164ff;
      border-color: #045cff;
      box-shadow: 0 4px 11px rgba(55, 125, 255, 0.35);
    }
  }
  .details{
    border: 1px solid #e7eaf3 ;
    transition: 0.3s;
    display: block;
    padding: 15px 30px;
    color: #1e2022;
    border-radius: 0.25rem;
    box-shadow: 0 0 35px rgba(140, 152, 164, 0.125);
    font-family: 'Poppins';
  }
}

</style>
